import { render, staticRenderFns } from "./EDIOrder.vue?vue&type=template&id=2376dfbb&scoped=true&"
import script from "./EDIOrder.vue?vue&type=script&lang=js&"
export * from "./EDIOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2376dfbb",
  null
  
)

export default component.exports